import { render, staticRenderFns } from "./lnk-mvg.vue?vue&type=template&id=806e80d2&"
import script from "./lnk-mvg.vue?vue&type=script&lang=js&"
export * from "./lnk-mvg.vue?vue&type=script&lang=js&"
import style0 from "./lnk-mvg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports